"use client"

import type React from "react"
import { View, StyleSheet } from "react-native"
import { Text } from "react-native-paper"
import type { TabComponentProps } from "../../../types/tabs"

export const SummaryTab: React.FC<TabComponentProps> = ({ projectData, selectedNode }) => {
    return (
        <View style={styles.container}>
            <View style={styles.messageContainer}>
                <Text variant="headlineMedium" style={styles.messageText}>
                    Coming Soon
                </Text>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
    },
    messageContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingVertical: 100,
    },
    messageText: {
        fontWeight: "600",
        color: "#666",
    },
})
